export default async (value) => typeof value === 'number'
